import type { PaginationProps } from 'modules/types'
import type { ProductInquiry } from 'modules/productinquiry/product-inquiry.dto'
import CONSTANT from 'modules/constant'
import { API, download, headers } from './api'

export const productInquiryApi = API.injectEndpoints({
  endpoints: (builder) => ({
    getProductInquiryList: builder.mutation<PaginationProps<ProductInquiry>, FormData>({
      query: (formData) => ({
        url: CONSTANT.URL_PRODUCT_INQUIRY_LIST,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: formData
      })
    }),
    downloadProductInquiryList: builder.mutation<PaginationProps<ProductInquiry>, FormData>({
      query: (formData) => ({
        url: CONSTANT.URL_PRODUCT_INQUIRY_DOWNLOAD,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body: formData,
        responseHandler: download,
        formData: true
      })
    }),
    getDcxtRefIdList: builder.mutation<string[], { search: string }>({
      query: (body) => ({
        url: CONSTANT.URL_PRODUCT_INQUIRY_DCXT_REF_ID_LIST + `?search=${body.search}`,
        method: 'GET',
        headers: headers()
      })
    }),
    sendProductInquiryToConnex: builder.mutation<{ message: string; jobId: string }, void>({
      query: () => ({
        url: CONSTANT.URL_PRODUCT_INQUIRY_SEND_TO_CONNEX,
        method: 'POST',
        headers: headers()
      })
    })
  })
})

export const {
  useGetProductInquiryListMutation,
  useDownloadProductInquiryListMutation,
  useGetDcxtRefIdListMutation,
  useSendProductInquiryToConnexMutation
} = productInquiryApi
